/**
 * Branding del producto (logo, nombre) — controlado por UNA sola variable
 * (REACT_APP_BRAND), para que el mismo código sirva para varias marcas sin
 * tener que mantener archivos distintos por rama/cliente.
 *
 * .gitlab-ci.yml fija esta variable según la rama que se está construyendo
 * (parqueaderosecuador / parkeyplus / etc.) — acá solo se define qué logo y
 * qué nombre le corresponde a cada valor. Agregar una marca nueva es
 * agregar una entrada en MARCAS, no tocar ningún componente.
 *
 * Sin la variable (build local, `npm start`, ramas nuevas sin configurar
 * todavía), cae en 'parkey' — la marca genérica del producto.
 */

const MARCAS = {
  parkey: {
    nombre: 'Parkey',
    logoLogin: '/ParkeyLogoWhite.svg',
    logoHeader: '/ParkeyLogoWhite.svg',
  },
  parqueaderos_ecuador: {
    nombre: 'Parqueaderos Ecuador',
    logoLogin: '/PEcuadorLogo.png',
    logoHeader: '/ParqueaderosEcuadorLogo.png',
  },
};

const clave = (process.env.REACT_APP_BRAND || 'parkey').trim();
const marca = MARCAS[clave] || MARCAS.parkey;

export const BRANDING = marca;
